import { Injectable } from '@angular/core';
import { InformacionCobro, InformacionFacturas, FacturasGrupo } from 'app/entities/cobranza';
import { element } from 'protractor';

@Injectable({
  providedIn: 'root'
})
export class FuncionesCarteraService {

  constructor() { }
  
  public tipoFactura(factElect: string, factFisic: string): string{
    let tipoFactura: string;
    if(factElect === '1' && factFisic === '1'){
      return tipoFactura = 'Elect-Fís';
    }else if(factFisic === '1'){
      return tipoFactura = 'Fís.';
    }else if(factElect === '1'){
      return tipoFactura = 'Elect.';
    }else {
      return tipoFactura = 'N/A';
    }
  }

  public filtroUltimoCobro(cobros: Array<any>){
    if(cobros.length == 3){
      if(cobros[0].FechaCobro == cobros[1].FechaCobro){
        if(cobros[1].FechaCobro == cobros[2].FechaCobro){
          return this.Cobro(cobros);
        }else{
          return this.Cobro(cobros.splice(0, 2));
        }
      }else{
        return this.Cobro(cobros.splice(0, 1));
      }
    }else if(cobros.length == 2){
      if(cobros[0].FechaCobro == cobros[1].FechaCobro){
        return this.Cobro(cobros);
      }else{
        return this.Cobro(cobros.splice(0, 1));
      }
    }else if(cobros.length == 1){
      return this.Cobro(cobros);
    }
  }

  Cobro(cobro: Array<any>){
    let Cobro: InformacionCobro;
    let Factura: Array<InformacionFacturas> = [];
    let ID_cobro: Array<string> = [];
    cobro.forEach((element, i) => {
      Cobro = {
        ActividadCobro: element.ActividadCobro,
        DirAlternativa: element.DirAlternativa,
        FechaCobro: element.FechaCobro,
        llamar_confirmar: element.llamar_confirmar,
        FechaRegistro: element.FechaRegistro,
        HoraCobro: element.HoraCobro,
        ID_Cobrador: element.ID_Cobrador,
        JornadaCobro: element.JornadaCobro,
        NotasOtros: element.NotasOtros,
        ObservacionesCobro: element.ObservacionesCobro,
        Reprogramacion: element.Reprogramacion,
        ReprogramacionFecha: element.ReprogramacionFecha,
        Reprogramador: element.Reprogramador,
        TipoAbono: element.TipoAbono,
        TipoCobro: element.TipoCobro,
        UsuarioCreador: element.UsuarioCreador,
        estado_cobro: element.estado_cobro,
        Mes_FacturaAbono: element.Mes_FacturaAbono,
        MontoAbono_Cobro: element.MontoAbono,
        Grupo: {
          observacion_cartera: element.ObsCartera,
          observacion_contrato: element.observacion_contrato,
          celular_grupo: element.celular_grupo,
          direccion: element.direccion_sistema,
          direccion_fact: element.direccion_factura,
          direccion_cobro: element.direccion_cobro,
          telefono_grupo: element.telefono_grupo,
          factura_elec: element.fact_elect,
          factura_fisica: element.fact_fis
        }
      }
      Factura[i] = {
        FechaFac: element.FechaFac,
        ID_Cobro: element.ID_Cobro,
        ID_Factura: element.ID_Factura,
        NoBen: element.NoBen,
        NoFactura: element.NoFactura,
        Nombre_Fac: element.Nombre_Fac,
        Nvo_saldo: element.Nvo_saldo,
        Saldo_Ant: element.Saldo_Ant,
        Val_Tot: element.Val_Tot,
        Val_Unit: element.Val_Unit,
        Fecha_Pago: element.Fecha_Pago,
        creador_pago: element.creador_pago,
        MontoAbono_Factura: element.MontoAbono
      }
      ID_cobro[i] = element.ID_Cobro;
    });
    Cobro.Facturas = Factura;
    Cobro.ID_Cobro = ID_cobro;
    return Cobro;
  }

  public Facturas(facturas: Array<any>): FacturasGrupo {
    let array_facturasRmv: Array<any> = facturas.filter(factura => factura.empresa === 'Red Medica Vital');
    let array_facturasVm: Array<any> = facturas.filter(factura => factura.empresa === 'VitalMascotas');

    const InfoFacturasGrupo: FacturasGrupo = {
      Facturas_rmv: array_facturasRmv,
      Facturas_vm: array_facturasVm,
      Conteo_frmv: array_facturasRmv.length,
      Conteo_fvm: array_facturasVm.length,
      Radicado_rmv: array_facturasRmv.length ? array_facturasRmv[0].radicado : null,
      Radicado_vm: array_facturasVm.length ? array_facturasVm[0].radicado : null
    }

    return InfoFacturasGrupo;
  }
}
